// line for formatting
import {
  ClearRedirectUrlAction,
  SFDCAuthActions,
  SFDCAuthState,
  SetInitializedAction,
  SetRedirectUrlAction,
  SetSFDCAuthLoadingAction,
  SetSFDCAuthTokensAction,
  sfdcLocalStorageKeys,
} from "./types";

export const initialState: SFDCAuthState = {
  initialized: false,
  loading: false,
  sfdcAuthToken: null,
  sfdcIdToken: null,
  sfdcRefreshToken: null,
  redirectUrl: null,
};

export const setInitialized = (): SetInitializedAction => ({
  type: "SET_INITIALIZED",
});

export const setAuthLoading = (loading: boolean): SetSFDCAuthLoadingAction => ({
  type: "SET_SFDC_AUTH_LOADING",
  payload: loading,
});

export const setSFDCAuthTokens = (
  sfdcAuthToken: SFDCAuthState["sfdcAuthToken"],
  sfdcIdToken: SFDCAuthState["sfdcIdToken"],
  sfdcRefreshToken: SFDCAuthState["sfdcRefreshToken"]
): SetSFDCAuthTokensAction => ({
  type: "SET_SFDC_AUTH_TOKENS",
  payload: {
    sfdcAuthToken,
    sfdcIdToken,
    sfdcRefreshToken,
  },
});

export const setRedirectUrl = (url: string): SetRedirectUrlAction => ({
  type: "SET_REDIRECT_URL",
  payload: url,
});

export const clearRedirectUrl = (): ClearRedirectUrlAction => ({
  type: "CLEAR_REDIRECT_URL",
});

export const reducer = (state: SFDCAuthState, action: SFDCAuthActions): SFDCAuthState => {
  switch (action.type) {
    case "SET_INITIALIZED":
      return { ...state, initialized: true };
    case "SET_SFDC_AUTH_LOADING":
      return { ...state, loading: action.payload };
    case "SET_SFDC_AUTH_TOKENS": {
      const { sfdcAuthToken, sfdcIdToken, sfdcRefreshToken } = action.payload;
      handleLocalStorage(sfdcLocalStorageKeys.sfdcAuthToken, sfdcAuthToken);
      handleLocalStorage(sfdcLocalStorageKeys.sfdcIdToken, sfdcIdToken);
      handleLocalStorage(sfdcLocalStorageKeys.sfdcRefreshToken, sfdcRefreshToken);

      return {
        ...state,
        sfdcAuthToken: action.payload.sfdcAuthToken,
        sfdcIdToken: action.payload.sfdcIdToken,
        sfdcRefreshToken: action.payload.sfdcRefreshToken,
      };
    }
    case "SET_REDIRECT_URL":
      localStorage.setItem("redirectUrl", action.payload);
      return { ...state, redirectUrl: action.payload };
    case "CLEAR_REDIRECT_URL":
      localStorage.removeItem("redirectUrl");
      return { ...state, redirectUrl: null };
    default:
      return state;
  }
};

export const handleLocalStorage = (key: string, value?: string | null) => {
  if (value) {
    localStorage.setItem(key, value);
  } else {
    localStorage.removeItem(key);
  }
};
